import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgProductSize',
  standalone: true,
})
export class ImgProductSizePipe implements PipeTransform {
  transform(value: string, size: number): unknown {
    let src = '';
    if (size < 768) {
      src = `${value.slice(0, -8)}250.webp`;
      return src;
    }
    return value;
  }
}
